<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="couponinfo" :rules="rules" ref="couponrule" label-width="120px" class="">
			<el-form-item label="活动编码" prop="code">
				<div style="float: left;">
					<el-input style="width: 90%;" clearable v-model="couponinfo.code" disabled="true"></el-input>
				</div>
				<div>
					<el-button type="primary" @click="createCode" style="display: inline;" >获取编码</el-button>
				</div>	
			</el-form-item>
			<el-form-item label="发放数量" prop="count">
				<el-input-number style="" v-model="couponinfo.count" :precision="0" :min="1" :max="100" label="发放数量"></el-input-number>
			</el-form-item>
			<el-form-item label="活动类型" prop="type">
			    <el-radio-group v-model="couponinfo.type" @input="typeChange">
					<el-radio label="cash">现金券</el-radio>
					<!-- <el-radio label="discount">折扣券</el-radio>
					<el-radio label="fullreduction">满减券</el-radio> -->
			    </el-radio-group>
			</el-form-item>
			
			<el-form-item v-show="couponinfo.type == 'cash'" label="抵扣金额" prop="discount">
				<el-input-number style="" v-model="couponinfo.discount" :precision="0" :min="1" :max="100"></el-input-number>
				元
			</el-form-item>
			<el-form-item v-show="couponinfo.type == 'discount'" label="折扣" prop="percent">
				<el-input-number style="" v-model="couponinfo.percent" :precision="0" :min="1" :max="100"></el-input-number>
				折
			</el-form-item>
			<el-form-item v-show="couponinfo.type == 'fullreduction'" label="满减" >
				满
				<el-input-number style="width: 200px;" v-model="couponinfo.full" :precision="2" :min="1" :max="500" ></el-input-number>
				元，减
				<el-input-number style="width: 200px;" v-model="couponinfo.mins" :precision="2" :min="0" :max="100" ></el-input-number>元
			</el-form-item>
			
			<el-form-item label="活动日期" prop="daterange">
				<el-date-picker value-format="yyyy-MM-dd" v-model="couponinfo.daterange" type="daterange"
					  start-placeholder="开始日期"  end-placeholder="结束日期" >
				</el-date-picker>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<div style="text-align: center;">
				<!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="confirmAdd">发 布</el-button>
			</div>
		</span>
	</div>
</template>

<script>
	import { getCouponCode,sendCoupons } from '/static/apiUrl.js'
	export default {
		name : 'AddCoupons',
		data() {
			return {
				couponinfo : {
					code : '',
					count : 0,
					type : '',
					userange : '所有档口',
					daterange : '',
					discount : 0 , // 抵扣金额
					percent : 100 , //几几折
					full : 0 , //满多少
					mins : 0 , //减多少
				},
				rules: {
					code : [
						{ required: true, message: '请输入活动编码', trigger: 'blur'}
					],
					count : [
						{ required: true, message: '请输入发放的优惠券数量', trigger: 'blur'},
						{ type: 'number', min: 1, max: 100, message: '优惠券数量在1~100之间', trigger: ['change','blur'] }
					],
					type : [
						{ required: true, message: '请选择优惠券类型', trigger: 'blur'}
					]
				}
				
			}
		},
		mounted() {
			
		},
		methods: {
			clearData(){
				this.couponinfo = {
					"code": "",
					"count": 1,
					"type": "",
					"userange": "",
					"daterange": "",
					"deductionamount": 1,
					"discount": 0,
					"percent": 100,
					"full": 0,
					"mins": 0,
				}
			},
			createCode() {
				getCouponCode().then(res => {
						if(0 == res.code){
							this.couponinfo.code = res.data
						}else{
							this.$message.error(res.msg)
						}
					})
			},	
			confirmAdd(){
				this.$refs["couponrule"].validate((valid) => {
					if (valid) {
						sendCoupons({
							usrId: "",
							code: this.couponinfo.code,
							count: this.couponinfo.count,
							type: this.couponinfo.type,
							value: this.getContentValue(this.couponinfo.type, this.couponinfo)+"",
							begintime: this.couponinfo.daterange ? this.couponinfo.daterange[0] +' 00:00:00' : '',
							overtime: this.couponinfo.daterange ? this.couponinfo.daterange[1] + ' 23:59:59' : ''
						}).then(res => {
							if(0 == res.code){
								console.log(res)
								this.clearData();
								this.$message.success('发放活动成功')
								this.$emit("couponNeedRefrash",true)
							}else{
								this.$message.error(res.msg)
							}
						})
					}else{
						console.log('1')
					}
				})
			},
			getContentValue(type,val){
				if('cash' == type){
					return val.discount
				}else if('discount' == type){
					return val.percent
				}else if('fullreduction' == type){
					return val.full+ '-'+val.mins
				}
			},
			typeChange(val){
				console.log(val)
				
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.dialog-footer{
		text-align: center;
	}
	
</style>